import { FormEvent, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import type { SearchHit } from "@shared/types";

export function SearchBox({ autoFocus, initial = "" }: { autoFocus?: boolean; initial?: string }) {
  const [q, setQ] = useState(initial);
  const [hits, setHits] = useState<SearchHit[]>([]);
  const [open, setOpen] = useState(false);
  const nav = useNavigate();

  useEffect(() => {
    if (q.trim().length < 2) {
      setHits([]);
      return;
    }
    const t = setTimeout(() => {
      api<{ results: SearchHit[] }>(`/api/search?q=${encodeURIComponent(q)}`)
        .then((r) => {
          setHits(r.results);
          setOpen(true);
        })
        .catch(() => setHits([]));
    }, 180);
    return () => clearTimeout(t);
  }, [q]);

  function go(e: FormEvent) {
    e.preventDefault();
    if (!q.trim()) return;
    if (hits[0]) nav(hits[0].href);
    else nav(`/search?q=${encodeURIComponent(q)}`);
    setOpen(false);
  }

  return (
    <form className="search-wrap" onSubmit={go}>
      <div className="search-row">
        <div className="search-field">
          <input
            autoFocus={autoFocus}
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Ross River Manning roughness · models using 2011 LiDAR · HEC-RAS bridge blockage"
            aria-label="Search models, studies, assumptions"
            onFocus={() => hits.length && setOpen(true)}
          />
          {open && hits.length > 0 && (
            <ul className="suggest">
              {hits.slice(0, 8).map((h) => (
                <li key={h.objectId}>
                  <button
                    type="button"
                    className="suggest-item"
                    onClick={() => {
                      nav(h.href);
                      setOpen(false);
                    }}
                  >
                    <span className="font-data" style={{ fontSize: 10, color: "var(--cyan)" }}>
                      {h.objectType}
                    </span>
                    <strong>{h.title}</strong>
                    <span className="muted small">{h.snippet}</span>
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>
        <button className="btn" type="submit">
          Search
        </button>
      </div>
    </form>
  );
}
